import ApiClient from 'api-client/ApiClient'
import { getDomainId } from 'api-client/helpers'
import { isFederatedUser } from 'app/plugins/account/components/ssoManagement/helper'

const { hagrid, keystone } = ApiClient.getInstance()

export const getIdps = async () => keystone.getIdentityProviders()

export const addIdp = async (body) => keystone.addIdentityProvider(body)

export const deleteIdp = async () => keystone.deleteIdentityProvider()

export const updateIdp = async (body) => keystone.updateIdentityProvider(body)

export const getSsoDetails = async () => hagrid.getSsoDetails()

export const loadSsoConfig = async () => hagrid.getSsoConfig()

export const createSsoConfig = async (config) => hagrid.createSsoConfig(config)

export const deleteSsoConfig = async () => hagrid.deleteSsoConfig()

export const deleteGroupMapping = async (id) => keystone.deleteGroupMapping(id)

export const deleteGroup = async (id) => keystone.deleteGroup(id)

export const deleteFederatedUsers = async () => {
  try {
    const users = await keystone.getUsers({ domainId: getDomainId() })
    const federatedUsers = users?.filter(isFederatedUser)
    if (federatedUsers?.length === 0) return

    await Promise.allSettled(federatedUsers?.map((user) => keystone.deleteUser(user?.id)))
  } catch (err) {
    throw err
  }
}
